"use client"

import { useCallback, useEffect, useRef, useState } from "react"

type Props = {
  inView: boolean
  number: string | number
  maximumFractionDigits?: number
  forceInteger?: boolean
}

const TransitionNumbersCounter = ({
  inView,
  number,
  maximumFractionDigits = 1,
  forceInteger,
}: Props) => {
  const parsedNumber =
    typeof number === "string" ? Number(number.toString().replace(/,/g, "")) : number
  const numberValue = parsedNumber
  const isWholeNumber = Number.isInteger(numberValue)
  const shouldForceInteger = forceInteger !== undefined ? forceInteger : isWholeNumber
  const displayMaximumFractionDigits = shouldForceInteger ? 0 : maximumFractionDigits

  // Base accumulator determines speed (#ticks ~= 50). For integers, ensure minimum step of 1
  const rawAccumulator = numberValue / 50
  const accumulator = shouldForceInteger ? Math.max(1, Math.ceil(rawAccumulator)) : rawAccumulator
  const [state, setState] = useState<number | string>(0)
  const [finished, setFinished] = useState(false)
  const valueRef = useRef(0)
  const tickTime = accumulator < 1 ? 35 : 50

  const updateCounterState = useCallback(() => {
    if (valueRef.current < numberValue) {
      let result: number
      if (shouldForceInteger) {
        // Always advance by whole numbers
        result = Math.ceil(valueRef.current + accumulator)
      } else {
        result =
          accumulator < 1
            ? Math.ceil((valueRef.current + accumulator) * 10) / 10
            : Math.ceil(valueRef.current + accumulator)
      }
      if (result > numberValue) return setState(number)
      setState(result)
      valueRef.current = result
    } else {
      setFinished(true)
    }
    setTimeout(updateCounterState, tickTime)
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [])
  useEffect(() => {
    if (inView) {
      updateCounterState()
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [inView])

  if (isNaN(numberValue)) return number
  return (
    <>
      {finished
        ? number
        : state.toLocaleString("he-IL", {
            maximumFractionDigits: displayMaximumFractionDigits,
          })}
    </>
  )
}

export default TransitionNumbersCounter
